import { Injectable } from "@angular/core";

@Injectable()
export class KeenTrackingService {
    event(_name: string, _eventData = null) {}
    async setEventBase() {}
    commit() {}
    post(_usage: any) {}
}
